export const TABLocatorWebRoute = 'tablocator'
